import {React, useMemo} from "react";
import {useSelector} from "react-redux";
import Button from "@mui/material/Button";
import {CircularProgress, TextField, Typography, MenuItem, Select, FormControl} from "@mui/material";
import EditProfileIcon from "../../../Assets/images/icons/edit";
import {useNavigate} from "react-router-dom";

// Helper function to extract country code and number
const parsePhoneNumber = (phoneNumber, countries) => {
    if (!phoneNumber) return { countryCode: "", number: "" };

    // Try to find matching country code
    const sortedCountries = [...countries].sort((a, b) => b.phone_code.length - a.phone_code.length);
    for (let country of sortedCountries) {
        if (phoneNumber.startsWith(country.phone_code)) {
            return {
                countryCode: country.phone_code,
                number: phoneNumber.substring(country.phone_code.length).trim()
            };
        }
    }

    // If no country code found, assume it's just the number
    return { countryCode: "", number: phoneNumber };
};

const EditFormInput = ({label,isEditing, handleInputChange, editedProfile, inputName, inputValue,type,readOnly,icon,showInProfile, isPhone, countries = []}) => {

    // Parse phone number when it's a phone field
    const { countryCode, phoneNumber } = useMemo(() => {
        if (isPhone && inputValue) {
            const parsed = parsePhoneNumber(inputValue, countries);
            return {
                countryCode: parsed.countryCode,
                phoneNumber: parsed.number
            };
        }
        return { countryCode: "", phoneNumber: inputValue };
    }, [isPhone, inputValue, countries]);

    const handlePhoneChange = (newCountryCode, newNumber) => {
        if (newCountryCode && newNumber) {
            // Combine country code and number
            const fullNumber = `${newCountryCode}${newNumber}`;
            handleInputChange(inputName, fullNumber);
        } else if (newNumber) {
            // If no country code but has number
            handleInputChange(inputName, newNumber);
        } else {
            handleInputChange(inputName, "");
        }
    };

    return (
        <>
            <div style={{
                display : (!showInProfile && !isEditing) ? "none" : "flex"
            }} className={icon ? 'input-row d-flex' : 'input-row d-flex input-row-with-icon'}>
                {
                    icon ?
                        <div className={'icon-label'}>
                            <img src={icon}  />
                        </div>
                        :
                        <Typography className={'input-label'}>
                            {label}
                        </Typography>
                }

                {
                    isEditing ? (
                        isPhone ? (
                            // Phone number input with country code
                            <div style={{display: 'flex', gap: '10px', width: '100%', alignItems: 'center'}}>
                                <FormControl variant="standard" sx={{minWidth: 100}}>
                                    <Select
                                        value={countryCode || "+1"}
                                        onChange={(e) => handlePhoneChange(e.target.value, phoneNumber)}
                                        variant="standard"
                                        disableUnderline
                                        className={'edit-input'}
                                        style={{width:'100%'}}
                                    >
                                        {countries.map((country) => (
                                            <MenuItem key={country.id} value={country.phone_code}>
                                                {country.name} {country.phone_code}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <TextField
                                    value={phoneNumber || ""}
                                    onChange={(e) => handlePhoneChange(countryCode, e.target.value)}
                                    size="small"
                                    type="tel"
                                    variant="standard"
                                    fullWidth
                                    className={'edit-input'}
                                    placeholder="Phone number"
                                    InputProps={{
                                        disableUnderline: true,
                                        readOnly: readOnly
                                    }}
                                />
                            </div>
                        ) : (
                            // Regular input
                            <TextField
                                value={inputValue || ""}
                                onChange={(e) => handleInputChange(inputName, e.target.value)}
                                size="small"
                                type={type}
                                variant="standard"
                                fullWidth
                                multiline
                                className={'edit-input'}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: readOnly
                                }}
                            />
                        )
                    ) : (
                        isPhone ? (
                            // Display formatted phone number
                            <Typography className={'input-label'}>
                                {inputValue || "Not provided"}
                            </Typography>
                        ) : (
                            // Regular display
                            <Typography className={'input-label'}>
                                {inputValue}
                            </Typography>
                        )
                    )
                }
            </div>
        </>
    );
};

export default EditFormInput;